const paymentMethodEnvVarValues = {
  card: 'CARD',
  googlePay: 'GOOGLEPAY',
  applePay: 'APPLEPAY',
  payPal: 'PAYPAL',
  klarna: 'KLARNA',
}

export default paymentMethodEnvVarValues